import { For } from 'solid-js';
import type { Tone } from '~/types/game';

interface SegBarProps {
  on: number;
  total: number;
  tone?: Tone | '';
}

export function SegBar(props: SegBarProps) {
  return (
    <div class="segbar">
      <For each={Array.from({ length: props.total }, (_, i) => i)}>
        {(i) => <i class={i < props.on ? `on ${props.tone ?? ''}` : ''} />}
      </For>
    </div>
  );
}
